import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { UncontrolledTooltip } from 'reactstrap';
import { SwitchItem } from '../../../components';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';

interface UserBrand {
  _id: string;
  name: string;
}

interface User {
  defaultUserBrand: UserBrand;
  [key: string]: any;
}

interface SetDefaultBrandSwitchOwnProps {
  userBrand: UserBrand;
  className?: string;
}

interface SetDefaultBrandSwitchStateProps {
  user: User;
  notify: Notify;
  updateCurrentUser: (user: User, notify: Notify, arg: null) => Promise<void>;
  setUserBrandValue: (data: { userBrandId: string; key: string; value: boolean }) => void;
}

type SetDefaultBrandSwitchProps = SetDefaultBrandSwitchOwnProps & SetDefaultBrandSwitchStateProps;

const SetDefaultBrandSwitch: React.FC<SetDefaultBrandSwitchProps> = ({
  user,
  userBrand,
  notify,
  className,
  updateCurrentUser,
  setUserBrandValue
}) => (
  <div id={`defaultBrandSwitch${userBrand._id}`} className={'display-inline ' + className || ''}>
    <SwitchItem
      value={user.defaultUserBrand._id === userBrand._id}
      isDisabled={user.defaultUserBrand._id === userBrand._id}
      margin="0"
      changeCallback={async (checked) => {
        if (checked) {
          setUserBrandValue({
            userBrandId: userBrand._id,
            key: 'defaultValues',
            value: true
          });

          setUserBrandValue({
            userBrandId: user.defaultUserBrand._id,
            key: 'defaultValues',
            value: false
          });

          await updateCurrentUser(
            {
              ...user,
              defaultUserBrand: userBrand
            },
            notify,
            null
          );
        }
      }}
    />
    {user.defaultUserBrand._id !== userBrand._id && (
      <UncontrolledTooltip
        autohide={false}
        placement="right"
        target={`defaultBrandSwitch${userBrand._id}`}
      >
        {getTranslationKey('userBrand.setAsStandard')}
      </UncontrolledTooltip>
    )}
  </div>
);

interface StateProps {
  notify: Notify;
  auth: User;
}

function mapStateToProps({ notify, auth }: StateProps) {
  return { notify, user: auth };
}

export default connect(mapStateToProps, actions)(SetDefaultBrandSwitch);
